/* eslint spaced-comment: 0 */
/* eslint no-tabs: 0 */
/* eslint no-mixed-spaces-and-tabs: 0 */
/* eslint key-spacing: 0 */
/* eslint padded-blocks: 0 */
/* eslint no-trailing-spaces: 0 */
/* eslint space-before-blocks: 0 */
/* eslint eqeqeq: 0 */
/* eslint space-before-function-paren: 0 */
/* eslint no-multiple-empty-lines: 0 */
/* eslint quotes: 0 */
/* eslint brace-style: 0 */
/* eslint comma-style: 0 */
/* eslint operator-linebreak: 0 */
/* eslint keyword-spacing: 0 */
/* eslint camelcase: 0 */
/* eslint comma-dangle: 0 */
/* eslint yoda: 0 */
/* eslint indent: 1 */
/* eslint no-unreachable: 1 */
/* eslint no-unused-vars: 1 */
require('date-time-format-timezone')

import config from '@/config.js'
import moment from 'moment'

export default {
  /*
  * フィルターの寿命を計算
  * @param Object
  * @return {flow:remainFlowPercent, time:elapsedTimePercent}
  */
  calcFilterLifePercent (filter) {
    // Flowによる残存洗浄可能量（パーセント）算出
    if (filter.maxLifeSpanFlow <= 0) return {flow: 0, time: 0} // フェールセーフ
    let remainFlowPercent = ((filter.maxLifeSpanFlow - (filter.flow < 0 ? 0 : filter.flow)) / filter.maxLifeSpanFlow) * 100

    // Timeによる経過時間（パーセント）算出
    let fromNow = Date.now() - filter.lastReplacementTime
    let elapsedTimePercent = fromNow / filter.maxLifeSpanTime * 100

    // 限界値を超えていたら限界値を返す
    return {
      flow: remainFlowPercent < 0 ? 0 : Math.round(remainFlowPercent),
      time: elapsedTimePercent > 100 ? 100 : Math.round(elapsedTimePercent)
    }
  },
  // ミリ秒をヶ月に変換
  convertSecondToMonth (second) {
    let convData = second / 60 / 60 / 24 / 30 / 1000 // ヶ月
    let convDataRound = Math.round(convData)
    return convDataRound
  },
  // 逆変換
  reverseSecondToMonth (month) {
    let convData = month * 60 * 60 * 24 * 30 * 1000 // ヶ月
    let convDataRound = Math.round(convData)
    return convDataRound
  },
  convertUnit (flow, unit) {
    if (unit === 'liter') {
      return this.customRound((flow / 1000), 3)
    } else if (unit === 'gal') {
      return this.customRound(((flow / 1000) * 0.26417205235815), 3)
    }
    return this.customRound(flow, 3)
  },
  reverseUnit (flow, unit) {
    // DBは整数しか許容しないため四捨五入で変換する
    if (unit === 'liter') {
      return Math.round((flow * 1000))
    } else if (unit === 'gal') {
      return Math.round(((flow * 1000) / 0.26417205235815))
    }
    return Math.round(flow)
  },
  convertPressureUnit (pressure, pressurUnit) {
    if (pressurUnit === 'MPa') {
      return this.customRound((pressure / 1000000), 2)
    } else if (pressurUnit === 'PSI') {
      return this.customRound((pressure * 0.000145), 2)
    }
    return this.customRound(pressure, 2)
  },
  reversePressureUnit (pressure, pressurUnit) {
    if (pressurUnit === 'MPa') {
      return this.customRound((pressure * 1000000), 2)
    } else if (pressurUnit === 'PSI') {
      return this.customRound((pressure / 0.000145), 2)
    }
    return this.customRound(pressure, 2)
  },
  convertTemperatureUnit (temperature, temperatureUnit) {
    if (temperatureUnit === '°F') {
      return this.customRound((temperature * 1.8 + 32), 2)
    } else if (temperatureUnit === '°C') {
      return this.customRound(temperature, 1)
    }
    return this.customRound(temperature, 1)
  },
  reverseTemperatureUnit (temperature, temperatureUnit) {
    if (temperatureUnit === '°F') {
      return this.customRound(((temperature - 32) / 1.8), 1)
    }
    return this.customRound(temperature, 1)
  },
  customRound (val, precision) {
    // 小数点を移動させる為の数を10のべき乗で求める
    var digit = Math.pow(10, precision)
    // 四捨五入したい数字に digit を掛けて小数点を移動
    val = val * digit
    // roundを使って四捨五入
    val = Math.round(val)
    // 移動させた小数点を digit で割ることでもとに戻す
    val = val / digit
    return val
  },
  generateUuid () {
    // https://github.com/GoogleChrome/chrome-platform-analytics/blob/master/src/internal/identifier.js
    // const FORMAT: string = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx";
    let chars = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.split('')
    for (let i = 0, len = chars.length; i < len; i++) {
      switch (chars[i]) {
        case 'x':
          chars[i] = Math.floor(Math.random() * 16).toString(16)
          break
        case 'y':
          chars[i] = (Math.floor(Math.random() * 4) + 8).toString(16)
          break
      }
    }
    return chars.join('')
  },
  numberFormatter (num, locale) {
    return new Intl.NumberFormat(locale).format(num)
  },
  dateFormatter (locale, date, options) { // date は unixTimeStamp 単位はミリ秒
    try {
      return new Intl.DateTimeFormat(locale, options).format(date)
    } catch (error) {
      return null
    }
  },
  dispServicesAdds (data) {
    for (let i = 0, dataLen = data.length; i < dataLen; i++) {
      // 要素を追加
      data[i].dispServices = this.dispServicesAdd(data[i])
    }
    return data
  },
  dispServicesAdd (data) {
    // サービスごとに1レコードにする(複数ポートのサービスは複数になってしまうため)
    var workServises = data.services
    var workDispServises = []
    var teatedServiceIds = []
    for (let j = 0, servicesLen = workServises.length; j < servicesLen; j++) {
      if (!teatedServiceIds[workServises[j].serviceId]) {
        // 存在しない
        workDispServises[j] = workServises[j]
        if (workServises[j].serviceId === 5 || workServises[j].serviceId === 4 || workServises[j].serviceId === 3) {
          // サービス、ポートごとの情報をまとめる
          workDispServises[j].details = this.dispServicesAddPortNest(workServises, workServises[j].serviceId)
        }
      }
      // 処理したServiceIDを保持
      teatedServiceIds[workServises[j].serviceId] = true
    }
    // 要素を追加
    return workDispServises
  },
  dispServicesAddPortNest (workServises, workServiceId) {
    // ポートごとのの情報を一レコードないにネストする
    var details = []
    for (let i = 0, len = workServises.length; i < len; i++) {
      if (workServises[i].serviceId === workServiceId) {
        // ポートごとの情報をまとめる
        details.push(workServises[i])
      }
    }
    return details
  },
  getDateTimeUnixTimestamp (date, time) {
    const dateTimeString = (date + ' ' + time).replace(/-/g, '/')
    let unixTimeStamp = Math.floor(new Date(dateTimeString).getTime() / 1000)
    return unixTimeStamp - (unixTimeStamp % (15 * 60))
  },
  formatDateForDatePickerAndTime (timestamp, locale, timezone, format, isMilliSeconds = false) {
    moment.locale(locale)
    if (isMilliSeconds) {
      timestamp = Math.floor(timestamp / 1000)
    }
    return moment.unix(timestamp).tz(timezone).format(format)
  },
  getDateOptions (period, isXAxisLabel = false) {
    if (isXAxisLabel) {
      switch (period) {
        case '15m':
          return {year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric'}
        case '1h':
          return {year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric'}
        case '1d':
          return {year: 'numeric', month: 'numeric', day: 'numeric'}
        case '1w':
          return {year: 'numeric', month: 'numeric', day: 'numeric'}
        case '1M':
          return {year: 'numeric', month: 'long'}
      }
    } else {
      switch (period) {
        case '15m':
          return {month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric'}
        case '1h':
          return {month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric'}
        case '1d':
          return {month: 'numeric', day: 'numeric'}
        case '1w':
          return {month: 'numeric', day: 'numeric'}
        case '1M':
          return {year: 'numeric', month: 'long'}
      }
    }
    return {month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric'}
  },
  /**
   * カレンダーの週の開始曜日を設定する
   * 0:日曜始まり
   * 1:月曜始まり
   */
  firstDayOfWeek (locale) {
    switch (locale) {
      case 'ja-JP':
        return 0
      case 'ja':
        return 0
      case 'en-US':
        return 0
      case 'en':
        return 0
      case 'en-GB':
        return 1
      case 'ru-RU':
        return 1
      case 'ru':
        return 1
      case 'uk-UA':
        return 1
      case 'uk':
        return 1
      case 'de-DE':
        return 1
      case 'de':
        return 1
      default:
        return 0
    }
  },
  /**
   * ドメイン別設定値取得
   */
  getDomainConfig () {
    let domain = document.domain
    let whiteLabel = config.whitelabel
    for (var key in whiteLabel) {
      if (domain.match(key)) {
        return whiteLabel[key]
      }
    }
    return whiteLabel['aqua.harps4.com']
  },
  
  isHarps4(){
    let hostname = location.hostname
    if (hostname === 'aqua.harps4.com' ||
        hostname === 'stage-1505758733-aqua.harps4.com' ||
        hostname === 'localhost' ||
        hostname === 'localhost.aqua.harps4.com')
    {
      console.log('harps4')
      return true
    }else{
      return false
    }
  },
  
  /**
   *  組織カテゴリのリストに名称をセット
   */
  setNameCustomerCategories ($t, list) {
    for (var i = 0; i < list.length; i++) {
      // 言語ファイルからの値を上書きする
      list[i].name = this.setNameCustomerCategory($t, list[i].name, list[i].customerCategoryId)
    }
    return list
  },
  /**
   *  組織カテゴリの名称をセット
   */
  setNameCustomerCategory ($t, name, customerCategoryId) {
    let wkName = ''
    let keyName = ''
    // 言語ファイルのキーを設定
    keyName = 'aplix-use-only.customer-categories.' + customerCategoryId
    // 文言取得
    wkName = $t(keyName)
    // キー名を出力する場合は存在しなかったと判定する
    if (wkName !== keyName) {
      // 言語ファイルからの文言を上書きする
      name = wkName
    }
    return name
  },
  /**
   *  ロールに対しての編集権限チェック
   */
  checkEditableRole (targetRoleId, userRoleId) {
    // 存在確認
    if (config.accountEditableRoles[userRoleId]) {
      // 編集可能な権限のリストを取得
      let accountEditableRoles = config.accountEditableRoles[userRoleId]
      if (accountEditableRoles.indexOf(targetRoleId) >= 0) {
        // 権限あり
        return true
      }
    }
    return false
  },
  
  /**
   * ブラウザ種別判定
   */
  iOS () {
    const ua = navigator.userAgent
    const ret =
      ua.indexOf('iPhone') >= 0 ||
      ua.indexOf('iPad') >= 0 ||
      ua.indexOf('iPod') >= 0
    return ret
  },

  safari () {
    const ua = navigator.userAgent
    const ret =
      ua.indexOf('Safari') >= 0 &&
      ua.indexOf('Chrome') < 0 // Android Chrome には 'Safari' がある
    return ret
  },

  android () {
    const ua = navigator.userAgent
    const ret =
      ua.indexOf('Android') >= 0
    return ret
  },

  ie11(){
    const ua = navigator.userAgent
    const ret = 
      ua.indexOf("Trident/7") >= 0
    return ret
  },
  
  // ログインユーザがRootかどうか
  isRoot (roles) {
    // ロール名を取得
    let roleName = roles[0]['name']
    // ルートかどうか
    if (roleName == config.role.Root) {
      return true
    }
    return false
  }
}



// WEBPACK FOOTER //
// ./src/utils/utils.js